module.exports = __webpack_public_path__ + "img/gestante.1c5b7a76.png";